import React from 'react';
import PropTypes from 'prop-types';

import { Box, Divider } from '@mui/material';

import ArrowSquareInIcon from '../../../../assets/icons/ArrowSquareInIcon';
import CircularEditIcon from '../../../../assets/icons/CircularEditIcon';
import CircularReverseIcon from '../../../../assets/icons/CircularReverseIcon';
import CircularTickIcon from '../../../../assets/icons/CircularTickIcon';
import StatusDisputeIcon from '../../../../assets/icons/StatusDisputeIcon';
import { BLACK } from '../../../../theme/colorConstants';

import { TIMECARD_HISTORY_EVENT_TYPES } from './timecardHistoryConstants';

const { clockIn, clockOut, dispute, resolve, edit, sendForReview, approve, finalize } =
  TIMECARD_HISTORY_EVENT_TYPES;
export const getEventIcon = (eventType) => {
  if (eventType === clockIn || eventType === clockOut) {
    return ArrowSquareInIcon;
  }

  if (eventType === dispute) {
    return StatusDisputeIcon;
  }

  if ([approve, resolve, finalize].includes(eventType)) {
    return CircularTickIcon;
  }

  if (eventType === edit) {
    return CircularEditIcon;
  }

  if (eventType === sendForReview) {
    return CircularReverseIcon;
  }

  return null;
};
const HistoryStepper = ({ eventType, index, numOfEvents }) => {
  const EventIcon = getEventIcon(eventType);
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        mt: 2.5,
      }}
    >
      <EventIcon />
      <Divider
        sx={{
          alignSelf: 'center',
          height: '100%',
          borderRight:
            index < numOfEvents - 1 ? `2px dotted ${BLACK[60]}` : '0px solid transparent',
        }}
        orientation="vertical"
        flexItem
        variant="middle"
      />
    </Box>
  );
};
HistoryStepper.propTypes = {
  eventType: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  numOfEvents: PropTypes.number.isRequired,
};

export default HistoryStepper;
